import { CONSULTANT_API_URL } from '../../constants/config'
import { request } from './config'
import { query } from './../utilities'

export const fetchOpportunityInfo = (
  opportunityId,
  headers,
  httpVerb,
  requestData
) =>
  request(
    `${CONSULTANT_API_URL}/Opportunity/${opportunityId}/info/oly`,
    headers,
    httpVerb,
    requestData
  )

export const fetchIndividualEstimate = (
  opportunityId,
  estimateId,
  headers,
  httpVerb,
  requestData
) =>
  request(
    `${CONSULTANT_API_URL}/Opportunity/${opportunityId}/quote/${estimateId}/oly`,
    headers,
    httpVerb,
    requestData
  )

export const fetchEstimates = (opportunityId, headers, httpVerb, requestData) =>
  request(
    `${CONSULTANT_API_URL}/Opportunity/${opportunityId}/oly`,
    headers,
    httpVerb,
    requestData
  )
export const fetchUserActivity = (consultantEmail, headers, httpVerb) => {
  return request(
    `${CONSULTANT_API_URL}/Opportunity/Consultant/CustomerAnalytics/${consultantEmail}`,
    headers,
    httpVerb
  )
}
